import type { RequestStatus } from "@gw/shared-types";
import { statusLabel } from "@/lib/labels";

interface Props {
  status: RequestStatus;
}

export function StatusPill({ status }: Props) {
  return (
    <span
      className={"status-pill " + status.toLowerCase()}
      role="status"
      aria-label={`Status: ${statusLabel(status)}`}
    >
      <span className="dot" aria-hidden="true" />
      {statusLabel(status)}
    </span>
  );
}
